import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Exige sessão VÁLIDA. A leitura do localStorage é síncrona de propósito: a tela protegida não chega
 * a montar antes da decisão (nada de piscar conteúdo e cair no login depois).
 *
 * Por que valida o CONTEÚDO e não só a presença: 103 lugares do app leem `user.cliente_id` sem
 * guarda. Enquanto esta fronteira só conferia se a string existia, um `user` gravado como `"null"`,
 * `"{}"` ou JSON corrompido passava — e a tela estourava com
 * "Cannot read properties of null (reading 'cliente_id')", que foi exatamente o erro visto em
 * produção na varredura de 23/08. Guardar aqui conserta os 103 de uma vez; patchear cada call site
 * seria 103 chances de esquecer um.
 *
 * O desvio por "conta suspensa" foi removido: mandava pra `/planos`, rota que deixou de existir
 * quando o produto virou ferramenta interna.
 */
// Exportada: o NotFound decide por ela se o 404 fica dentro do shell (uma autoridade para "está logado?").
export const sessaoValida = () => {
  try {
    if (!localStorage.getItem('token')) return false;
    const bruto = localStorage.getItem('user');
    if (!bruto) return false;
    const u = JSON.parse(bruto);
    // cliente_id é o que TODA tela usa pra pedir dado: sem ele a sessão é inútil, mesmo com token.
    return !!(u && typeof u === 'object' && u.cliente_id);
  } catch {
    return false; // JSON corrompido é sessão inválida, não exceção pro usuário ver
  }
};

const ProtectedRoute = ({ children }) => (sessaoValida() ? children : <Navigate to="/login" replace />);

export default ProtectedRoute;
